import { render } from "./Service.vue?vue&type=template&id=5e3bd066"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__